'use strict';
import {epics as reduxEpics} from '../redux';
import {epics as authFirebaseEpics} from './authFirebase';
import {epics as initAuthEpics} from './initAuth';
import {epics as logoutUserEpics} from './logoutUser';
import {epics as onAuthSuccessEpics} from './onAuthSuccess';
import {epics as onLocationChangeEpics} from './onLocationChange';
import {epics as onLoginEpics} from './onLogin';
import {epics as onLoginViewEpics} from './onLoginView';
import {epics as stateGoPostAuthEpics} from './stateGoPostAuth';
import {epics as userLogAppInfoEpics} from './userLogAppInfo';

export const epics = [
  ...reduxEpics,
  ...authFirebaseEpics,
  ...initAuthEpics,
  ...logoutUserEpics,
  ...onAuthSuccessEpics,
  ...onLocationChangeEpics,
  ...onLoginEpics,
  ...onLoginViewEpics,
  ...stateGoPostAuthEpics,
  ...userLogAppInfoEpics,
];



// WEBPACK FOOTER //
// ./src/js/auth/epics/index.js